export const getMask = _ref => {
  let {
    size,
    opacityTop,
    opacityBottom
  } = _ref;
  return "linear-gradient(180deg, rgba(255, 255, 255, ".concat(opacityTop, "), black) center top / 100% ").concat(size, "px no-repeat,\n  linear-gradient(180deg, black, black) center ").concat(size, "px / 100% calc(100% - ").concat(size * 2, "px) no-repeat,\n  linear-gradient(180deg, black, rgba(255, 255, 255, ").concat(opacityBottom, ")) center bottom / 100% ").concat(size, "px no-repeat");
};